module.exports = __webpack_public_path__ + "img/401.7b190de7.svg";